// This is a very specific endpoint to allow accountants
// to upload files in the corporation documents level

import { FileBasic } from '@commenda/types/src/file/types';
import { fetcher } from '@commenda/utils';
import { Frequency, LegacyDocumentType } from '@prisma/client';

export type AddFilesToCorporationDTO = {
  files: FileBasic[];
  isTimeSensitive: boolean;
  documentType: LegacyDocumentType;

  title?: string;
  frequency?: Frequency;
  fiscalYear?: number;
  quarters?: number[];
  months?: number[];
  folderId?: string;
};

const addFilesToCorporation = async (
  corporationId: number,
  data: AddFilesToCorporationDTO,
  token: string
) => {
  const res = await fetcher(
    `file/corporation/${corporationId}`,
    { method: 'POST', body: data },
    token
  );

  return res;
};

export { addFilesToCorporation };
